import { render, staticRenderFns } from "./20220916index.vue?vue&type=template&id=0d1360ca&scoped=true&"
import script from "./20220916index.vue?vue&type=script&lang=js&"
export * from "./20220916index.vue?vue&type=script&lang=js&"
import style0 from "./20220916index.vue?vue&type=style&index=0&id=0d1360ca&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1360ca",
  null
  
)

export default component.exports